import { lighten } from 'polished';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { COLORS } from 'styles/constants';

interface ContainerProps {
  isOpen: boolean;
}

export const Container = styled.ul<ContainerProps>`
  position: fixed;
  top: 10vh;
  left: 0%;

  width: 100vw;
  background: #fff;
  padding: 1rem;
  overflow: hidden;
  z-index: 999;

  display: ${(props) => (props.isOpen ? 'flex' : 'none')};
  flex-direction: column;
  align-items: center;

  img {
    border-radius: 50%;
  }

  @media only screen and (min-width: 900px) {
    top: 10vh;
    position: absolute;
    width: 300px;
    transform: translateX(-66.5%);

    border: 1px solid #ccc;
    border-radius: 5px;
  }

  @media only screen and (min-width: 1400px) {
    top: 7vh;
  }
`;

export const ProfileContainer = styled(Link)`
  width: 100%;
  margin-bottom: 0.7rem;
  padding: 10px;

  border: none;
  background: rgb(235, 235, 235);

  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    background: #fff;
  }
`;

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const MenuItem = styled(Link)`
  width: 100%;
  padding: 20px;
  margin-bottom: 0.7rem;

  border: none;
  background: rgb(235, 235, 235);

  &:hover {
    background: #fff;
  }

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ReputationDisplay = styled.div`
  margin-top: 5px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  span {
    color: red;
  }
`;

export const PointDisplay = styled.div`
  margin-top: 5px;

  display: flex;
`;

export const NotVerifiedDisplay = styled.div`
  margin-top: 5px;

  display: flex;
  align-items: center;
`;

export const SignOutButton = styled.button`
  width: 100%;
  padding: 1rem;

  border: none;
  color: #fff;
  background: ${lighten(0.1, COLORS.errorRed)};

  &:hover {
    background: ${lighten(0.15, COLORS.errorRed)};
  }
`;
